// POLICYHR2 (2026-10-16): the roles the SERVER lets WRITE a policy, mirrored here ONCE so every
// mount of the Policy Repository derives its canManage from one rule.
//
// MUST EQUAL backend/app/routers/policies.py's POLICY_WRITE_ROLES, which all three writes (upload,
// PATCH and DELETE) read from a single tuple. backend/scripts/verify/verify_policyhr2.py PARSES
// BOTH FILES and fails if the two lists differ, so this is a CHECKED mirror and not a comment
// promising a mirror. The guard it replaces compared the frontend list against a hardcoded JS copy
// of the server's, which could not see the two sides drifting apart at all.
//
// WHY THIS IS ITS OWN MODULE, which is the part worth reading before moving it again:
//
//   * IT WAS IN Dashboard.js, where it could only ever gate Dashboard's own mount. Four components
//     mount the repository, and the App.js mount independently hardcoded `role === 'compliance'` -
//     so the two screens disagreed with each other, and both with the server, about one rule.
//   * MOVING IT INTO PolicyRepository.js LOOKED RIGHT AND BROKE SIX TESTS. More than five suites
//     call jest.mock('./PolicyRepository', ...) and re-declare that module's exports by hand, so
//     the constant became undefined inside Dashboard the moment any of them ran, and
//     `POLICY_WRITE_ROLES.includes(role)` threw. A value that gates access must not live in a
//     module that tests routinely replace.
//   * A MODULE WITH NO IMPORTS AND NO COMPONENT is not worth mocking, so nothing mocks it, so the
//     allowlist is the same list at runtime and under test.
//
// A POSITIVE LIST, NEVER AN EXCLUSION. The previous POLICYHR build existed because this gate was
// once written as `!isCountryLead`, which silently granted the upload form to hr the moment hr was
// routed through the mount - and every upload then returned 403 from the server. Naming the
// admitted roles means a role added to this portal later is READ ONLY here until somebody grants it
// on purpose, instead of being granted by not being the one role someone thought to exclude.
//
// hr IS ADMITTED BY MARIE-LYNNE'S DECISION of 2026-10-16: HR manages the Policy Repository and may
// upload, replace and archive exactly as the coo may. Every other role stays read-only.
export const POLICY_WRITE_ROLES = ['compliance', 'admin', 'coo', 'hr'];

// Whether this account may use the repository's write controls. A FUNCTION rather than an inline
// `.includes` at each mount, so a mount cannot get the comparison subtly wrong (case, a stray
// secondary_role) and so there is one place to change if the rule ever stops being a flat list.
export function canManagePolicies(role) {
  return POLICY_WRITE_ROLES.includes(role);
}
